class HiddenTitle {
    /**
     * @param {Object} config
     * @param {string} [config.hiddenTitle] - Titel für den Tab, wenn er nicht mehr aktiv ist
     */
    constructor(config) {
        this.hiddenTitle = config.hiddenTitle || '👋 Hast du nicht etwas vergessen?';
        this.documentTitle = document.title;
    }

    init() {
        this.registerHiddenTitle();
    }

    // ============= Public API =============

    registerHiddenTitle() {
        document.addEventListener("visibilitychange", (event) => {
            if (document.visibilityState === 'hidden') {
                document.title = this.hiddenTitle;
            } else {
                document.title = this.documentTitle;
            }
        });
    }
}
